var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgYoutube = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1174_32828)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.4502 9.70586V13.9217L14.502 11.8211L10.4502 9.70586Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM18.7529 7.48809C19.2041 7.94219 19.3506 8.97637 19.3506 8.97637C19.3506 8.97637 19.5 10.1922 19.5 11.4051V12.5418C19.5 13.7576 19.3506 14.9705 19.3506 14.9705C19.3506 14.9705 19.2041 16.0047 18.7529 16.4588C18.2381 16.9973 17.6687 17.053 17.3467 17.0844C17.3113 17.0879 17.279 17.0911 17.25 17.0945C15.1523 17.2439 12 17.2498 12 17.2498C12 17.2498 8.10059 17.2146 6.89941 17.1004C6.84099 17.0891 6.76983 17.0804 6.68913 17.0706C6.3085 17.0242 5.71549 16.9519 5.24414 16.4588C4.7959 16.0047 4.64941 14.9705 4.64941 14.9705C4.64941 14.9705 4.5 13.7547 4.5 12.5418V11.4051C4.5 10.1922 4.65234 8.97637 4.65234 8.97637C4.65234 8.97637 4.7959 7.94219 5.24707 7.48809C5.76185 6.94955 6.33134 6.8939 6.65332 6.86244C6.68866 6.85898 6.72102 6.85582 6.75 6.85234C8.84766 6.7 11.9971 6.7 11.9971 6.7H12.0029C12.0029 6.7 15.1523 6.7 17.25 6.85234C17.279 6.85582 17.3113 6.85898 17.3467 6.86244C17.6687 6.8939 18.2381 6.94955 18.7529 7.48809Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1174_32828"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "currentColor"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube.e40be870.svg";
export { ForwardRef as ReactComponent };